import React from "react";
import "./Contact.css";
import { useNavigate } from 'react-router-dom';

export default function Contact() {
    const navigate = useNavigate();

  return (
    <div>
         <button className="menu-btn-ab" onClick={() => navigate('/')}>
        Menu
      </button>
    <div className="contact-page">
      <div className="contact-container">
        <h1 className="contact-title">Կապ մեզ հետ</h1>

        <p className="contact-description">
          Հաճախորդների հարմարության համար կարող եք կապ հաստատել մեզ հետ հետևյալ
          տարբերակներով․
        </p>

        <div className="contact-info">
          <div className="contact-item">
            <h3>📞 Պատվերների համար</h3>
            <a href="+374xxxxxxxxxx" className="contact-link">
               (WhatsApp, Viber)
            </a>
          </div>

          <div className="contact-item">
            <h3>🚚 Առաքումների համար</h3>
            <a href="tel:" className="contact-link">
              {/* +374 33 010160 */}
            </a>
          </div>

          <div className="contact-item">
            <h3>📧 Էլ. հասցե</h3>
            <a
              href="mailto:acc.ecogarden@gmail.com"
              className="contact-link"
            >
              {/* acc.ecogarden@gmail.com */}
            </a>
          </div>
        </div>
      </div>
    </div>
    </div>

  );
}
